import { ClustererOptions } from '@react-google-maps/marker-clusterer';
import googleMapReact from 'google-map-react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { ICoordinates } from 'src/types/location';
import { formatImagePath } from 'src/utils/formatter';
import { appStore } from '~/mobx/appStore';

export const defaultCoordinates: ICoordinates = {
  lat: 24.681530159926,
  lng: 46.698331379151,
};

export const defaultZoom: number = 15;

export const googleMapBootstrapURLKeys = (): googleMapReact.BootstrapURLKeys => {
  return { key: appStore.settings?.google_maps_pk || '', libraries: ['geometry'] };
};

export const defaultGoogleMapOptions: googleMapReact.MapOptions = {
  fullscreenControl: false,
  gestureHandling: 'greedy',
  zoomControl: false,
  scrollwheel: true,
  draggable: true,
  maxZoom: 24,
  minZoom: 2,
};

export const clustererOptions: ClustererOptions = {
  maxZoom: 7,
  averageCenter: true,
  zoomOnClick: true,
  calculator: (markers) => ({ text: Math.floor(markers.length / 2).toString(), index: 1, title: 'Cluster' }),
  styles: [
    {
      url: formatImagePath(`${Icons.Cluster}.svg`),
      height: 35,
      width: 35,
      textColor: 'white',
      className: 'd-flex align-items-center justify-content-center',
    },
  ],
};
